$(function () {
  initValidation();
  initEvents();

  //Set the inital state of the create account button
  $("#createAccountBtn").addClass('disabled');
  $("#createAccountBtn").prop('disabled', true);
});

function initEvents() {
  $("#AgreeToTerms").change(function () {
    if (this.checked) {
      $("#createAccountBtn").removeClass('disabled');
      $("#createAccountBtn").prop('disabled', false);
    }
    else {
      $("#createAccountBtn").addClass('disabled');
      $("#createAccountBtn").prop('disabled', true);
    }
  });

  $('#AgeOfMajorityCertification').on('change', function () {
    if ($(this).is(':checked')) {
      $('#ParentPanel').addClass('hidden');
    } else {
      $('#ParentPanel').removeClass('hidden');
    }
  });

  $('#PrimaryPhoneType').on('change', function () {
    if ($(this).val() !== 'Mobile') {
      $('#otpDiv').show();
    }
    else {
      $('#otpDiv').hide();
    }
  });
}

function initValidation() {
  $.validator.addMethod("reCaptcha",
    function (value, element, params) {
      var response = grecaptcha.getResponse();
      return response && response.length > 0;
    }, 'You must confirm you are not a robot.');

  //Match BaseController.IsValidPhoneNumberWithFormatting
  $.validator.addMethod("notFakePhone",
    function (value, element, params) {
      if (value) {
        var digits = value.replace(/\D+/g, '').split('');
        if (digits.length === 10) {
          if (digits[3] == '5' && digits[4] == '5' && digits[5] == '5') { //(XXX) 555-XXXX
            return false;
          }
          else if (digits[3] == digits[4] && digits[4] == digits[5] && digits[5] == digits[6] && digits[6] == digits[7] && digits[7] == digits[8] && digits[8] == digits[9]) { //(XXX) 111-1111
            return false;
          }
        }
        else {
          return false;
        }
      }

      return true;
    }, 'Phone is invalid.');

  $.validator.addMethod("mobileTypeRequiredIfOptIn",
    function (value, element) {
      if ($('#OptInToTextMessages').length > 0 && $('#OptInToTextMessages').is(':checked')) {
        if (value === 'Mobile') {
          return true;
        }
        else {
          return false;
        }
      }

      return true;
    }, 'You must enter a mobile number to opt in to text messages');

  $.validator.addMethod("waiverSignatureMatch",
    function (value, element) {
      return ($('#WaiverSignature').val() == ($('#FirstName').val() + ' ' + $('#LastName').val()));
    }, 'Your signature must match what you entered for your First and Last name.'
  );

  $("#CreateAccountForm").validate({
    rules: {
      FirstName: {
        required: true,
        minlength: 2,
        maxlength: 50
      },
      LastName: {
        required: true,
        minlength: 2,
        maxlength: 50
      },
      Email: {
        required: true,
        email: true,
        remote: createMailgunEmailRemote('#Email'),
        maxlength: 100
      },
      PrimaryPhone: {
        required: true,
        phoneUS: true,
        notFakePhone: true
      },
      PrimaryPhoneType: {
        mobileTypeRequiredIfOptIn: true
      },
      Password: {
        required: true,
        passwordMeetsRequirements: true
      },
      ConfirmPassword: {
        required: true,
        equalTo: "#Password"
      },
      AgreeToTerms: {
        required: true,
        reCaptcha: true
      },
      WaiverSignature: {
        required: true,
        waiverSignatureMatch: true,
      },
      WaiverParentName: {
        required: {
          depends: function () {
            return ($('#AgeOfMajorityCertification').is(':checked') == false);
          }
        }
      },
      WaiverParentRelationship: {
        required: {
          depends: function () {
            return ($('#AgeOfMajorityCertification').is(':checked') == false);
          }
        }
      },
      WaiverParentEmail: {
        required: {
          depends: function () {
            return ($('#AgeOfMajorityCertification').is(':checked') == false);
          }
        },
        email: true,
        remote: createMailgunEmailRemote('#WaiverParentEmail', { skipDuplicateCheck: true })
      },
      WaiverParentPhone: {
        required: {
          depends: function () {
            return ($('#AgeOfMajorityCertification').is(':checked') == false);
          }
        },
        phoneUS: true
      },
      WaiverParentSignature: {
        required: {
          depends: function () {
            return ($('#AgeOfMajorityCertification').is(':checked') == false);
          }
        },
        trimEqualTo: '#WaiverParentName'
      }
    },
    messages: {
      FirstName: {
        required: "First Name is required.",
        minlength: "First Name must be at least {0} characters.",
        maxlength: "First Name must be less than {0} characters."
      },
      LastName: {
        required: "Last Name is required.",
        minlength: "Last Name must be at least {0} characters.",
        maxlength: "Last Name must be less than {0} characters."
      },
      Email: {
        required: "Email is required.",
        email: "Email is invalid",
        maxlength: "Email must be less than {0} characters."
      },
      PrimaryPhone: {
        required: "Phone is required.",
        phoneUS: 'Phone is invalid.',
        notFakePhone: 'Phone is invalid.'
      },
      Password: {
        required: "Password is required."
      },
      ConfirmPassword: {
        required: "Confirm Password is required.",
        equalTo: "Passwords must match."
      },
      AgreeToTerms: {
        required: 'You must agree to the Terms of Use.',
        reCaptcha: 'You must confirm you are not a robot.'
      },
      WaiverSignature: {
        required: "You must type your full legal name to sign the waivers.",
      },
      WaiverParentName: {
        required: "Parent/Guardian Full Legal Name is required.",
      },
      WaiverParentRelationship: {
        required: "Parent/Guardian Relationship is required.",
      },
      WaiverParentEmail: {
        required: "Parent/Guardian Email is required.",
        email: "Parent/Guardian Email must be a valid email address."
      },
      WaiverParentPhone: {
        required: "Parent/Guardian Phone is required.",
        phoneUS: "Parent/Guardian Phone must be a valid phone number."
      },
      WaiverParentSignature: {
        required: "Your Parent/Guardian must type their full legal name to sign the waiver.",
        trimEqualTo: "Parent/Guardian signature must match Parent/Guardian Full Legal Name"
      }
    },
    errorContainer: '#errorMessageBoxCreate',
    errorLabelContainer: '#errorListCreate',
    errorElement: "li",
    onkeyup: false
  });

  initMailgunBypass('#CreateAccountForm', ['#Email', '#WaiverParentEmail']);
}
